import * as React from "react";
import type { SVGProps } from "react";
const SvgUserLogin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.7}
      d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M8.571 10.607c0 1.837 1.592 3.429 3.429 3.429s3.429-1.592 3.429-3.429V9.75c0-1.837-1.592-3.429-3.43-3.429-1.836 0-3.428 1.592-3.428 3.429zm8.143 5.135c.67.266 1.286.94 1.286 1.722v1.806a.5.5 0 0 1-.352.477L12 21.5l-5.66-1.922a.5.5 0 0 1-.34-.474v-1.64c0-.783.617-1.456 1.286-1.722.983-.39 2.516-.85 4.715-.85s3.73.46 4.713.85"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgUserLogin;
